const locale = () => navigator.language ?? 'en-US';

export const formatWatermarkDate = (): string =>
  new Date().toLocaleDateString(locale(), { month: 'long', day: '2-digit', year: 'numeric' });

export const formatWatermarkTime = (): string =>
  new Date().toLocaleTimeString(locale(), { hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short' });

export const formatWatermarkDateTime = (): string => `${formatWatermarkDate()} - ${formatWatermarkTime()}`;
